import { createModalStore } from '@/shared/lib/modal';

export const useOnboardingModalStore = createModalStore({}, false);
